import React, { Component, Fragment } from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'
import Panel from '../../../../UniformComponents/Panel'
import Select from '../../../form/Select'
import './dataviewer.scss'
import Button from '../../../../UniformComponents/Button'
import Modal from '../../../../UniformComponents/Modal'
import DataTable from '../../../DataTable'
import Filters from './Filters'
import DataViewerStore from './DataViewerStore'
import Anchor from '../../../../UniformComponents/Anchor'

@observer
class DataViewer extends Component {
    filters = [{}]

    constructor(props) {
        super(props)
        this.dataViewerStore = new DataViewerStore(props.store)
    }

    componentDidMount() {
        const { store } = this.props
        store.breadcrumps = [
            {
                name: 'intranet',
                url: '/intranet',
                title: 'Intranet',
            },
            {
                name: 'dataViewer',
                url: '/intranet/dataViewer',
                title: 'Data Viewer',
            },
        ]

        this.dataViewerStore.init(store)
    }

    renderFilters = () => {
        const { table } = this.state

        if (!table) return null

        return (
            <div style={{ padding: '20px', marginTop: '20px', border: '1px solid #777', borderRadius: '5px' }}>
                {this.filters.map(this.renderFilter)}
            </div>
        )
    }

    render() {
        const { dataViewerStore } = this
        return (
            <Fragment>
                {!dataViewerStore.loading && (
                    <Panel cssClass="dataviewer">
                        <div className="row">
                            <Select
                                style={{ padding: '10px 0px', width: '100%' }}
                                placeholder="Schema"
                                options={dataViewerStore.schemas}
                                defaultValue={dataViewerStore.selectedSchema}
                                onBlur={dataViewerStore.changeSchema}
                            />
                        </div>
                        <div className="row">
                            <Select
                                style={{ padding: '10px 0px', width: '100%' }}
                                placeHolder="Table"
                                defaultValue={dataViewerStore.selectedTable}
                                options={dataViewerStore.tables}
                                onBlur={dataViewerStore.changeTable}
                            />
                        </div>
                        <div className="row">
                            <Filters store={dataViewerStore} />
                        </div>
                        <div className="row">
                            <Button
                                label="View Results"
                                cssClass="primary regular"
                                onClick={dataViewerStore.viewResults}
                            />
                            <Button
                                label="Download"
                                cssClass="secondary regular"
                                onClick={dataViewerStore.download}
                            />
                        </div>
                        {dataViewerStore.showData && (
                            <DataTable
                                key={dataViewerStore.dataTableKey}
                                columns={dataViewerStore.generateTableColumns(dataViewerStore.cols)}
                                loadRecords={dataViewerStore.getData}
                                recordCount={dataViewerStore.recordCount}
                                dataSet={dataViewerStore.dataSet}
                                showPagination
                            />
                        )}
                    </Panel>
                )}
                <Modal
                    show={dataViewerStore.showDownloadModal}
                    onClose={dataViewerStore.hidedownloadModal}
                >
                    <div className="uc-modal__header">
                        <h2>{i18n.t('report_download_as_csv')}</h2>
                    </div>
                    <div className="uc-modal__button-panel" style={{ marginTop: '16px' }}>
                        <Anchor
                            isExternal
                            target="_blank"
                            href={dataViewerStore.downloadUrl}
                        >
                            {i18n.t('download')}
                        </Anchor>
                    </div>
                </Modal>
            </Fragment>
        )
    }
}

export default DataViewer
